import React, { useEffect, useState } from 'react';
import useGlobal from '../../store';
import ReactGA from 'react-ga';
import * as utils from '../../services/utils';
import CurrencySymbol from '../General/CurrencySymbol';
import PopoverNotice from '../General/PopoverNotice';

const GiftIdeaCard = (props) => {

    const [isSaving, setIsSaving] = useState(false);

    const [response, giftideaActions] = useGlobal(
        state => state.response,
        actions => actions.giftideaActions
    );

    useEffect(() => {
        if(!response || response.type !== "addgiftidea") {
            return;
        }
        setIsSaving(false);
    }, [response]);

    const domain = function(input) {
        if(!input || input === "") {
            return "";
        }
        input = Array.isArray(input) ? input[0] : input;
        input = input.replace('www.', '');
        var l = document.createElement("a");
        l.href = input;
        return l.hostname;
    }

    const getItemUrl = (item) => {
        if(!item.url || item.url === "") {
            return "#";
        }
        if(item.url.indexOf('amazon.com') !== -1 
            || item.url.indexOf('amazon.co.uk') !== -1
            || item.url.indexOf('amazon.de') !== -1
            || item.url.indexOf('amazon.fr') !== -1
            || item.url.indexOf('amazon.es') !== -1) {
            return formatAmazonUrl(item.url);
        } else if(item.url.includes("target.com")) {
            var t = item.url.match(/.*A-(.*?)($|#|\?)/);
            if(t && t.length > 1) {
                return 'https://goto.target.com/c/1430766/520943/2092?prodsku=' + t[1] + '&u=' + encodeURIComponent(item.url) + '&intsrc=PUI1_4061';
            }
        } 
        return "http://go.redirectingat.com/?id=86675X1539295&xs=1&url="+encodeURI(item.url)+"&sref="+encodeURI(window.location.href);
    }
    const formatAmazonUrl = (linkUrl) => {
        linkUrl = decodeURIComponent(linkUrl);
        if(linkUrl.indexOf('christmasli0b-20') === -1) {
            var parts = linkUrl.split("?");
            if(parts.length > 1) {
                var params = JSON.parse('{"' + decodeURI(parts[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
                params.tag = "christmasli0b-20";
                var queryString = Object.keys(params)
                        .map(function(k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]) })
                        .join('&');
                linkUrl = parts[0] + "?" + queryString;
            } else {
                linkUrl += "?tag=christmasli0b-20"; 
            }
        }
        return linkUrl;
    }

    const openLink = (item) => {
        let itemUrl = getItemUrl(item);
        window.open(itemUrl, '_blank');

        //TRACK REFERRAL CLICK EVENT
        let domain = utils.getDomain(item.url);
        let evtVal = item.price ? parseInt(item.price, 10) : 1;
        ReactGA.event({
            category: 'Referral Click',
            action: 'Gift Idea Item',
            label: domain,
            value: evtVal
        });
    }

    const addGiftIdea = () => {
        setIsSaving(true);
        let data = (props.item_id) ? {
            item_id: props.item_id,
            user_id: props.user.userID
        } : {
            id: props.id,
            user_id: props.user.userID
        };
        console.log('ADD GIFT IDEA', data);
        giftideaActions.addGiftIdea(data);
    }

    const buildAvatarUrl = (userData) => {
        if(userData.hasOwnProperty('avatarFile') && userData.avatarFile && (userData.avatarFile.indexOf('_avatar') > 0 || userData.avatarFile.length > 30)) {
	        return "https://weblight.imgix.net/avatars/"+userData.avatarFile + "?w=100&h=100&fit=facearea&faceindex=1&facepad=2";
	    }
	    if(userData.FBID && userData.FBID !== "0") {
	        return "https://graph.facebook.com/" + userData.FBID + "/picture?type=large";
	    }
	    if(userData.hasOwnProperty('avatarFile') && userData.avatarFile) {
	        return "https://weblight.imgix.net/avatars/"+userData.avatarFile;
	    }
	    return "https://weblight.imgix.net/avatars/man.png";
    }


    return ( 
        <div className="card item-card idea-card">
            {props.popular ? <span className="badge badge-info" style={{position: "absolute",top:"5px",right:"5px",zIndex:"1"}}><i className="flaticon-star"></i> POPULAR</span> : <></>}
            <div className="kt-padding-10 text-center card-top" onClick={() => openLink(props)}>
                <img src={props.pic ? props.pic : 'https://weblight.imgix.net/gift.png'} alt="Item" />
                <div className="badge badge-primary price-tag">
                    {!props.price || props.price === 0 
                        ? <h4 className="p-0 m-0">VIEW <i className="la la-external-link"></i></h4>
                    : <h4 className="p-0 m-0"><CurrencySymbol></CurrencySymbol>{props.price} <i className="la la-external-link"></i></h4> }
                </div>
            </div>
            <div className="card-body" onClick={() => openLink(props)}>
                <h5 className="card-title">{props.name}</h5>
                { (props.url && props.url !== "") ? 
                    <>
                        <p id={'item_' + props.itemID} style={{"display":"inline-block"}} className="card-text">{domain(props.url)} <i className="flaticon2-tag"></i>
                        </p>
                        <PopoverNotice title={'Link opens ' + domain(props.url)} trigger='hover' body='We earn small commissions on some purchases you make through our links. Thank you for supporting us.' placement='top' target={'item_' + props.itemID} ></PopoverNotice>
                        </>
                    : <></> }
                { props.itemDescription && props.itemDescription !== '0' ? <p className="card-text">{props.description}</p> : <></> }
            </div>
            <div className="card-footer text-right">
                <button onClick={() => addGiftIdea()} className="btn btn-success btn-block mr-2" style={{textTransform: "uppercase"}}>
                    { props.user ? 
                        <>
                            <img alt="avatar" className="avatar avatar-xs mr-2 hidden-sm" src={buildAvatarUrl(props.user)} />
                            ADD TO {props.user.FirstName}'s LIST
                        </>
                        : "ADD"
                    } 
                    { isSaving ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <></> }
                </button>
            </div>
        </div>);
}
export default GiftIdeaCard;